
import { Worksheet } from "./types";
import { supabase } from "@/integrations/supabase/client";

export const createSearchIndex = (
  name: string,
  subject: string,
  grade_level: string
): string => {
  return `${name} ${subject} ${grade_level}`.toLowerCase();
};

export const buildSearchIndexFromCurrentData = async (
  id: number,
  updates: Partial<Worksheet>
): Promise<string | undefined> => {
  if (!updates.name && !updates.subject && !updates.grade_level) {
    return undefined;
  }
  
  const { data: currentData } = await supabase
    .from("worksheets")
    .select("name, subject, grade_level")
    .eq("id", id)
    .single();
    
  if (currentData) {
    const name = updates.name || currentData.name;
    const subject = updates.subject || currentData.subject;
    const grade_level = updates.grade_level || currentData.grade_level;
    
    return createSearchIndex(name, subject, grade_level);
  }
  
  return undefined;
};
